import './SupportBlock.scss';
import * as React from 'react';
import * as Core from 'components/core';
import CurrentHQTime from 'components/CurrentHQTime';
export default () => (
  <div className="DocsSupportBlock">
    <div className="DocsSupportBlock-text">
      <p className="DocsSupportBlock-text-heading">Still have a question?</p>
      <p>Our support team is always happy to help.</p>
    </div>
    <div className="DocsSupportBlock-contact">
      <div className="DocsSupportBlock-contact-table">
        <div className="DocsSupportBlock-contact-table-row">
          <div className="DocsSupportBlock-contact-table-row-label">
            Business Hours
          </div>
          <div className="DocsSupportBlock-contact-table-row-value">
            M-F 9am-7pm (ET)
          </div>
        </div>
        <div className="DocsSupportBlock-contact-table-row">
          <div className="DocsSupportBlock-contact-table-row-label">
            Current time at our headquarters
          </div>
          <div className="DocsSupportBlock-contact-table-row-value">
            <strong>
              <CurrentHQTime noLabel />
            </strong>
          </div>
        </div>
      </div>
      <div className="DocsSupportBlock-contact-button">
        <Core.Link to="/support/" button>
          Contact Support
        </Core.Link>
      </div>
    </div>
  </div>
);
